export const FORM_CATEGORIES = [
  {
    // Fathom can only track numeric values for event, so we work around that
    // by assigning a number for each category.
    //
    // See: https://usefathom.com/docs/features/events
    fathomId: 'F4VHVRE6',
    label: 'New Project',
    key: 'new-project'
  },
  {
    fathomId: 'ST4LKVTK',
    label: 'Just saying hi',
    key: 'just-saying-hi'
  },
  {
    fathomId: '7C4OGR3L',
    label: 'Other',
    key: 'other'
  }
];

// These define texts depending oh the category that has been chosen
export const FORM_TEXTS = {
  message: {
    helpText: {
      'new-project':
        'Exciting. We’re always looking for new projects to work on. Please tell us a bit more about what you’re looking for.',
      'just-saying-hi':
        'Thanks. We would love to hear from you. Please tell us more.',
      default: 'We’re all ears. Please tell us more.'
    },
    placeholder: {
      'new-project':
        'Information about the scope, budget and timeline of your project is helpful',
      'just-saying-hi':
        'To get the ball rolling... What’s your favorite flag and why?',
      default: 'Please tell us more'
    }
  },
  details: {
    helpText: {
      'new-project':
        'Amazing, thanks for the details. Let us know how to reach you and we’ll be in touch soon.',
      'just-saying-hi': 'Oh, that’s interesting. We’ll be in touch soon.',
      default: 'Let us know how to reach you and we’ll be in touch soon.'
    }
  },
  success: {
    helpText: {
      'new-project':
        'Thanks for sending over details about our potential collaboration. We’ll be in touch with you shortly.',
      'just-saying-hi':
        'Thanks for getting in touch. We’ll be in touch with you shortly.',
      default:
        'Thanks for getting in touch. We’ll be in touch with you shortly.'
    }
  }
};
